export enum VerifierType {
  MORTGAGE = 'mortgage',
  TENANT = 'tenant_screening',
}

export enum FeatureFlagList {
  TrueworkJSEvents = 'truework_js_events_fe',
  POSFlow = 'tjs_pos_flow_frontend',
  UnifiedSearch = 'truework_direct_unified_search',
  RequireEmployerDetails = 'tenant-require-employer-details',
  DocumentsV2 = 'documents_v2',
}

enum TrueflagStatus {
  ENABLED = 'enabled',
  CONTROL = 'control',
  STRING = 'string',
}

export type Trueflags = {
  [flag in FeatureFlagList]: TrueflagStatus
}

export type APITrueflagResponse = {
  experiment_results: Trueflags
}

export enum TrueworkJsFeedbackReason {
  DONT_KNOW_PAYROLL_LOGIN = 'dont-know-payroll-login',
  UNABLE_TO_FIND_EMPLOYER = 'unable-to-find-employer',
  UNCOMFORTABLE_ENTERING_CREDENTIALS = 'uncomfortable-entering-credentials',
  DONT_HAVE_EMPLOYER = 'dont-have-employer',
  OTHER = 'other',
}

export type TrueworkJsFeedbackPayload = {
  feedback: TrueworkJsFeedbackReason
  instance_id: string
  other_feedback?: string
}

export type BusinessEntity = {
  company_id: number
  name: string
  email_required: boolean
  domain?: string
  logo_url?: string
}

export type DirectAPIErrorMessage = {
  message: string
}

export type DirectAPIError = {
  error: DirectAPIErrorMessage
}
